var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-overflow-temp',{key:_vm.keyNum,attrs:{"content":_vm.content,"max-lines":_vm.maxLines,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }